@if(allformFields){
<div class="my-20 mx-20">
    Add Allergies/Intolerance
</div>
<app-dynamic-forms-v2 [formFields]="allformFields" [formMetaData]="undefined">

</app-dynamic-forms-v2>

<div class="button-group my-15 g-just-flex" style="justify-content: flex-end; width: 100%; gap: 20px;">
    <button mat-flat-button (click)="submitAllergy()">Submit Allergy</button>
</div>
}